import { CommandType } from "../../../../common/services/cqs/CommandType";
import { Leveransplan } from "../../models/leveransvirkesplan-models";
import { LeveransplanCommandBase } from "./LeveransplanCommandBase";

export class CreateLeveransplanCommand extends LeveransplanCommandBase {
    readonly kvantitet: number;
    readonly period: string;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "CreateLeveransplanCommand";

    constructor(leveransplan: Leveransplan) {
        super(leveransplan.virkeskostnadGUID, leveransplan.period, CreateLeveransplanCommand.$type, CommandType.Insert);
        this.kvantitet = leveransplan.kvantitet;
    }
}
